import type { AssessmentQuestion } from '@entities/assessment'

import { AssessmentTopics } from '@entities/assessment'

import imgQuestion3 from '../../../../ui/images/questions/ela/grade-k4/question-3.png'
import imgQuestion5 from '../../../../ui/images/questions/ela/grade-k4/question-5.png'
import imgQuestion8 from '../../../../ui/images/questions/ela/grade-k4/question-8.png'

export const questions: AssessmentQuestion[] = [
  {
    name: 'grade_k4_1',
    title: 'Which word has the same vowel sound as “plane”?',
    topic: AssessmentTopics.ListeningAndSpeaking,
    answers: [
      {
        name: 'grade_k4_1_a',
        text: 'plan',
      },
      {
        name: 'grade_k4_1_b',
        text: 'planned',
      },
      {
        name: 'grade_k4_1_c',
        text: 'rain',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k4_2',
    title: 'Which sentence shows a polite way to ask for help?',
    topic: AssessmentTopics.ListeningAndSpeaking,
    answers: [
      {
        name: 'grade_k4_2_a',
        text: 'Help me now!',
      },
      {
        name: 'grade_k4_2_b',
        text: 'I need this done.',
      },
      {
        name: 'grade_k4_2_c',
        text: 'Could you please help me?',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k4_3',
    title: 'What does the expression “Piece of cake” mean?',
    topic: AssessmentTopics.ListeningAndSpeaking,
    image: imgQuestion3,
    answers: [
      {
        name: 'grade_k4_3_a',
        text: 'A slice of cake.',
      },
      {
        name: 'grade_k4_3_b',
        text: 'Something that is very easy.',
        correct: true,
      },
      {
        name: 'grade_k4_3_c',
        text: 'A small piece of food.',
      },
    ],
  },
  {
    name: 'grade_k4_4',
    title: 'Read the sentence:',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    detail: '“The loud thunder scared the puppy, so it hid under the bed until the storm passed.”',
    sentence: 'Why did the puppy hide under the bed?',
    answers: [
      {
        name: 'grade_k4_4_a',
        text: 'It was tired.',
      },
      {
        name: 'grade_k4_4_b',
        text: 'It was hungry.',
      },
      {
        name: 'grade_k4_4_c',
        text: 'It was scared by the thunder.',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k4_5',
    title: 'Read the sentence:',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    detail: '“The park was full of colorful flowers, buzzing bees, and singing birds on a sunny afternoon.”',
    sentence: 'What could you see and hear in the park?',
    image: imgQuestion5,
    answers: [
      {
        name: 'grade_k4_5_a',
        text: 'Flowers, bees, and birds.',
        correct: true,
      },
      {
        name: 'grade_k4_5_b',
        text: 'Cars and buses.',
      },
      {
        name: 'grade_k4_5_c',
        text: 'Snow and ice.',
      },
    ],
  },
  {
    name: 'grade_k4_6',
    title: 'Read the text:',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    detail: 'Liam and his sister Emma went to the beach last weekend. They built a big sandcastle together and collected seashells along the shore. Afterward, they enjoyed a picnic under a shady tree.',
    sentence: 'Where did Liam and Emma have their picnic?',
    answers: [
      {
        name: 'grade_k4_6_a',
        text: 'On the sandcastle.',
      },
      {
        name: 'grade_k4_6_b',
        text: 'On the beach chairs.',
      },
      {
        name: 'grade_k4_6_c',
        text: 'In a shade.',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k4_7',
    title: 'Which sentence is written correctly?',
    topic: AssessmentTopics.Writing,
    answers: [
      {
        name: 'grade_k4_7_a',
        text: 'yesterday we went to the park and played soccer.',
      },
      {
        name: 'grade_k4_7_b',
        text: 'Yesterday, we went to the park and played soccer. ',
        correct: true,
      },
      {
        name: 'grade_k4_7_c',
        text: 'Yesterday we went to the park and played Soccer.',
      },
    ],
  },
  {
    name: 'grade_k4_8',
    title: 'Choose the best word to complete the sentence:',
    topic: AssessmentTopics.Writing,
    detail: 'I have _____ homework to do tonight.',
    image: imgQuestion8,
    answers: [
      {
        name: 'grade_k4_8_a',
        text: 'many',
      },
      {
        name: 'grade_k4_8_b',
        text: 'much',
      },
      {
        name: 'grade_k4_8_c',
        text: 'a lot of',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k4_9',
    title: 'Which sentence uses punctuation correctly?',
    topic: AssessmentTopics.Writing,
    answers: [
      {
        name: 'grade_k4_9_a',
        text: 'Wow I can’t believe it!',
      },
      {
        name: 'grade_k4_9_b',
        text: 'Wow! I can’t believe it?',
      },
      {
        name: 'grade_k4_9_c',
        text: 'Wow! I can’t believe it!',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k4_10',
    title: 'Which word is a pronoun in this sentence?',
    topic: AssessmentTopics.Language,
    detail: 'Maria gave her book to Tom.',
    answers: [
      {
        name: 'grade_k4_10_a',
        text: 'Maria',
      },
      {
        name: 'grade_k4_10_b',
        text: 'her',
        correct: true,
      },
      {
        name: 'grade_k4_10_c',
        text: 'book',
      },
    ],
  },
  {
    name: 'grade_k4_11',
    title: 'Choose the sentence with correct subject-verb agreement:',
    topic: AssessmentTopics.Language,
    answers: [
      {
        name: 'grade_k4_11_a',
        text: 'The dogs runs fast.',
      },
      {
        name: 'grade_k4_11_b',
        text: 'The dog run fast.',
      },
      {
        name: 'grade_k4_11_c',
        text: 'The dogs run fast.',
      },
    ],
  },
  {
    name: 'grade_k4_12',
    title: 'Choose the sentence that uses a conjunction correctly:',
    topic: AssessmentTopics.Language,
    answers: [
      {
        name: 'grade_k4_12_a',
        text: 'She wanted to play outside or it was raining.',
      },
      {
        name: 'grade_k4_12_b',
        text: 'She wanted to play outside, and it was raining.',
      },
      {
        name: 'grade_k4_12_c',
        text: 'She wanted to play outside, but it was raining.',
        correct: true,
      },
    ],
  },
]
